module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/root//main-front.png?v=cd091dd1";